import React, { useState } from "react";
import { DatePicker, Form, Row } from 'antd';
import formItemLayout from "../../const/form/formItemLayout"; 

function RangeDatePicker({voucher, setVoucher}){
    let [ endOpen, setEndOpen ] = useState(false)

    function disabledStartDate(){
        if (voucher.beginDate || !voucher.endDate) {
            return false;
        }
        return voucher.beginDate.valueOf() > voucher.endDate.valueOf();
    };

    function disabledEndDate(){
        if (!voucher.endDate || !voucher.beginDate) {
            return false;
        }
        return voucher.endDate.valueOf() <= voucher.beginDate.valueOf();
    };

    function onChange(field, value){
        setVoucher(voucher = {...voucher,
            [field]: value
        })
    };

    function onStartChange(value){
        onChange("beginDate", value)
    };

    function onEndChange(value){
        onChange('endDate', value);
    };

    function handleStartOpenChange(open){
        if (!open) {
            setEndOpen(endOpen = true)
        }
    };

    function handleEndOpenChange(open){
        setEndOpen(endOpen = open)
    };
    
    return(
        <Row>
            <Form.Item 
                {...formItemLayout} 
                label={"Inicio"} 
                style={{marginTop: 25}}
                hasFeedback
                required={true}
            >
                <DatePicker
                    disabledDate={disabledStartDate}
                    showTime
                    format="DD-MM-YYYY HH:mm:ss"
                    value={voucher.beginDate}
                    placeholder="Inicio"
                    onChange={onStartChange}
                    onOpenChange={handleStartOpenChange}
                />
            </Form.Item>

            <Form.Item 
                {...formItemLayout} 
                label={"Fim"} 
                style={{marginTop: 25}}
                hasFeedback
                required={true}
            >
                <DatePicker
                    disabledDate={disabledEndDate}
                    showTime
                    format="DD-MM-YYYY HH:mm:ss"
                    value={voucher.endDate}
                    placeholder="Fim"
                    onChange={onEndChange}
                    open={endOpen}
                    onOpenChange={handleEndOpenChange}
                />
            </Form.Item>
        </Row>
    )
}

export default RangeDatePicker;


// WEBPACK FOOTER //
// ./src/components/common/RangeDatePicker.jsx